/* eslint-disable import/prefer-default-export */
export enum ContractColorTheme {
  'basic' = 'blue',
  'plus' = 'teal',
  'premier' = 'indigo',
  'undefined' = 'red',
}
